export default {
  title: 'プッシュ',
  name: {
    lastName: '過去の名称',
    required: '入力必須',
    label: '素材名',
    prefixLabel: '素材名のプレフィックス',
    suffixLabel: '素材名のサフィックス',
    code: {
      projectId: 'プロジェクトID',
      projectName: 'プロジェクト名',
      versionName: 'バージョン名',
      outputName: '作品名',
      platform: 'モバイルOS',
      autoIncrement: '自動ナンバー',
      creative_version: 'クリエイティブのバージョン',
    },
    validate: {
      repeat: 'クリエイティブネームが既に存在しています。',
    },
  },
  package: {
    size: '実際のパッケージサイズ {size} {symbol} {limit}',
    packError: 'パッケージ計算エラー。再度試行してください。',
  },
  channel: {
    title: 'プラットフォーム',
    selectAll: '全選択',
    selectReverse: '反転',
    selectCount: '選択済({count})',
    selectClear: 'クリア',
    selectTips: 'プッシュするアカウントまたは製品を選択してください',
    emptyTips: '利用可能なアカウントや製品はありません',
    removeMintegral:
      'メインアカウントを削除すると、そのメインアカウントに関連するサブアカウントも削除されます。削除してもよろしいですか？',
    removeUnity:
      'アカウントを削除すると、そのアカウントに関連する製品も削除されます。削除してもよろしいですか？',
    account: 'アカウント',
    accountMain: 'メインアカウント',
    accountChild: 'サブアカウント',
    product: '製品',
    creativeSet: 'クリエイティブグループ',
    inexistence: {
      product: '現在のプロジェクトに関連する製品は見つかりませんでした。',
    },
    applovinTooltip:
      'Applovinの各クリエイティブセットには、プレイアブル広告は1つのみ可能です。',
  },
  mtg: {
    save: {
      label: 'Mintegralダウンロード',
    },
  },
}
